<template>
  <div class="fill-height">
    <TabBasic ref="tabBasic" :items="items" show-breadcrumbs :user-id="selectedUserId" :filter-open="filterOpen">
      <template v-slot:header>
        <v-spacer/>
        <slot name="header"/>
        <v-col v-if="$route.name === 'alertHistory' && isOrganizationAdmin" cols="3">
          <SelectFilter v-model="selectedUserId" :items="users" show-all="" single-select
                        color="accentText" @openMenu="openMenu"/>
        </v-col>
      </template>
    </TabBasic>
  </div>
</template>

<script>
import TabBasic from "@/components/reusable/TabBasic/TabBasic";
import SelectFilter from "@/components/reusable/SelectFilter/SelectFilter";

export default {
  name: "AlertBasic",
  components: {SelectFilter, TabBasic},
  mounted() {
    if (this.isOrganizationAdmin) {
      this.getUsers()
    }
  },
  data() {
    return {
      tab: null,
      selectedUserId: this.$store.getters.getUserId,
      users: [],
      items: [
        {
          title: this.$t('notifications.history'),
          to: {
            name: 'alertHistory'
          }
        },
        {
          title: this.$t('alerts.scheduledAlerts'),
          to: {
            name: 'scheduledAlerts'
          }
        },
      ],
      openAddEditDialog: false,
      filterOpen: false,
    };
  },
  computed: {
    isOrganizationAdmin() {
      return this.$store.getters.isOrganizationAdmin;
    }
  },
  methods: {
    getUsers() {
      let url = this.$store.getters.getOrganizationUsers(this.$store.getters.getOrganizationId);
      this.loading = true;
      this.axios.get(url).then(({data}) => {
        this.users = [{value: 0, text: this.$t('alerts.allPeople')}, ...data.Result.map(user => ({
          value: user.UserID,
          text: user.FullName
        }))];
      }).finally(() => {
        this.loading = false;
      });
    },
    openMenu(val) {
      this.filterOpen = val;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "alert-basic";
</style>